'use strict'

/**
 * @classname ChangeFilterPrefecture
 * @classdesc 「都道府県絞り込み」を変更したとき都道府県を表示する
 */
export default class ChangeFilterPrefecture {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.show_scout_age')
	 */
	constructor($e, controller) {
		console.log('ChangeFilterPrefecture.constructor')
		this._$e = $e
		this._controller = controller
		this._$prefectureWrap = $('.prefecture-wrap')
		this._$e.on('change', () => this.onClick())
		this.onClick(0)
	}


	/**
	 * clickのコールバック
	 *
	 * @memberof ChangeFilterPrefecture
	 * @return {undefined}
	 */
	onClick(duration = 300) {
		console.log('ChangeFilterPrefecture.onClick')
		const $checked = $('[name=target_master_council_filtered]:checked');
		if ($checked.val() === '1') {
			this._$prefectureWrap
				.slideDown(duration)
				.find('.validate')
				.removeClass('ignore-validate')
		} else {
			this._$prefectureWrap
				.slideUp(duration)
				.find('.validate')
				.removeClass('is-invalid')
				.addClass('ignore-validate')
				.closest('.form-group')
				.find('.error-tip')
				.removeClass('show')
				.find('.error-tip-inner')
				.html('')
			this._$prefectureWrap.find('option').each((idx, e) => {
				const $e = $(e);
				$e.prop('selected', false);
			});
			this._$prefectureWrap.find('select').trigger('change');
		}
	}
}
